import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './NewCustomer.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';
import MapContainer from "../MapContainer/MapContainer";
import imageCompression from 'browser-image-compression';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import axios from 'axios';
import ImageUploader from "./ImageUploaded.jsx";
import CameraMultiComponent from "./CameraMultiComponent";

var customer_XHR={'abort' : ()=>{}};
var singleCustomer_DOM;
var singlePhoneCustomer_DOM;


class NewCustomer extends Component {
  url = `${process.env.REACT_APP_SSS}/dealer_img/`;
  constructor(props) {
    super(props);
    this.locationSelect=React.createRef();
    this.districtSelect = React.createRef();
    // this.distributorSelect = React.createRef();
    this.routeSelect = React.createRef();
    this.state = {
      company : '',
      person : '',
      address : '',
      gst : '',
      phone :'',
      districts : [],
      district :'',
      NewCustomers : [],
      customer_id : '',
      customer_type : 'D',
      category : '',
      specific_industries : '',
      specific_industry : '',
      locations : [],
      location : '',
      routes : [],
      route : '',
      retailer_schemes : [],
      retailer_scheme : '',
      zone : '',
      shopImage: { file: null, deleted: false, updated: false },
      boardImage: { file: null, deleted: false, updated: false },
      interiorImage: { file: null, deleted: false, updated: false },
      capturedPhotos : [],
      shopCamera : {file : null, isFile: false},
      boardCamera : {file : null, isFile: false},
      interiorCamera : {file : null, isFile: false},

    }
    this.formChange = this.formChange.bind(this);
    this.clearValuesinState = this.clearValuesinState.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleImageCapture = this.handleImageCapture.bind(this);

  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    singleCustomer_DOM = $(".single_customer_details").clone();
    $(".single_customer_details").remove();
    singlePhoneCustomer_DOM = $(".single_phone_customer_details").clone();
    $(".single_phone_customer_details").remove();
    this.getNewCustomerDistricts();    
    var obj_this = this;

    if(typeof geo !== 'undefined'){
      geo.getLocation(function(location){
        if(location && location.latitude) {
            obj_this.context.setLocation(location);
            obj_this.setState({
            coordinate : {lat : location.latitude, lng : location.longitude},
            });
        }
      });
    }
    $(".location_button").on("click",function(){
      if(typeof geo !== 'undefined'){
        geo.getLocation(function(location){
          if(location && location.latitude) {
              obj_this.context.setLocation(location);
              obj_this.setState({
                coordinate : {lat : location.latitude, lng : location.longitude},
              });         
          }
        });
      }
    });


    $(".customer_suggestions_container").on("mousedown",".single_customer_details",function(){
      $(".customer_suggestions_container").empty().css("display","none");
      const customer_id = $(this).attr("customer_id");
      obj_this.context.loading(1);
      const url = `${process.env.REACT_APP_SSS}/api/get/customer/details`;
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          customer_id : customer_id
        },
        type : "POST"
      }).done(function(return_data){

        var option2 = obj_this.state.categories.filter(item => item.value == return_data.customer.customer_category);
        // console.log(option);
        option2 = option2[0]?option2[0]:{};

        var option3 =return_data.locations.filter(item => item.value == return_data.customer.location_id);
        // console.log(option);
        option3 = option3[0]?option3[0]:{};

        var option4 = obj_this.state.specific_industries.filter(item => item.value == return_data.customer.specific_industry);
        // console.log(option);
        option4 = option4[0]?option4[0]:{};


        obj_this.setState({
          company : return_data.customer.name,
          person : return_data.customer.contact_person,
          phone : return_data.customer.tel_o,
          gst : return_data.customer.gst,
          district : return_data.customer.district,
          state : return_data.customer.state,
          address : return_data.customer.address,
          customer_id : customer_id,
          category : option2,
          location : option3,
          specific_industry : option4,
          locations : return_data.locations,
          route : return_data.route,
          // distributor : return_data.distributor,
          // coordinate : return_data.coordinate??'',
          coordinate : {lat : return_data.coordinate?.lat, lng : return_data.coordinate?.lng},
          retailer_scheme : return_data.retailer_scheme??'',
          shopImage: { ...obj_this.state.shopImage, imageUrl:`${process.env.REACT_APP_SSS}/dealer_img/`+return_data.customer.shop_image },
          boardImage: { ...obj_this.state.boardImage, imageUrl: `${process.env.REACT_APP_SSS}/dealer_img/`+return_data.customer.shop_board },
          interiorImage: { ...obj_this.state.interiorImage, imageUrl: `${process.env.REACT_APP_SSS}/dealer_img/`+return_data.customer.shop_interior },
          zone : return_data.zone,
          zones : return_data.zones,
          districts : return_data.districts,
          search : ''


        });
        obj_this.context.loading(0);
      });
    })
    $(".phone_suggestions_container").on("mousedown",".single_phone_customer_details",function(){
      $(".phone_suggestions_container").empty().css("display","none");
      const customer_id = $(this).attr("customer_id");
      obj_this.context.loading(1);
      const url = `${process.env.REACT_APP_SSS}/api/get/customer/details`;
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          customer_id : customer_id
        },
        type : "POST"
      }).done(function(return_data){

        var option2 = obj_this.state.categories.filter(item => item.value == return_data.customer.customer_category);
        option2 = option2[0]?option2[0]:{};

        var option4 = obj_this.state.specific_industries.filter(item => item.value == return_data.customer.specific_industry);
        option4 = option4[0]?option4[0]:{};

        var option3 =return_data.locations.filter(item => item.value == return_data.customer.location_id);
        option3 = option3[0]?option3[0]:{};

        obj_this.setState({
          company : return_data.customer.name,
          person : return_data.customer.contact_person,
          phone : return_data.customer.tel_o,
          gst : return_data.customer.gst,
          district : return_data.customer.district,
          state : return_data.customer.state,
          address : return_data.customer.address,
          customer_id : customer_id,
          category : option2,
          location : option3,
          specific_industry : option4,
          locations : return_data.locations,
          route : return_data.route,
          // distributor : return_data.distributor,
          // coordinate : return_data.coordinate??'',
          coordinate : {lat : return_data.coordinate?.lat, lng : return_data.coordinate?.lng},
          retailer_scheme : return_data.retailer_scheme??'',
          shopImage: { ...obj_this.state.shopImage, imageUrl:`${process.env.REACT_APP_SSS}/dealer_img/`+return_data.customer.shop_image },
          boardImage: { ...obj_this.state.boardImage, imageUrl: `${process.env.REACT_APP_SSS}/dealer_img/`+return_data.customer.shop_board },
          interiorImage: { ...obj_this.state.interiorImage, imageUrl: `${process.env.REACT_APP_SSS}/dealer_img/`+return_data.customer.shop_interior },
          zone : return_data.zone,
          zones : return_data.zones,
          districts : return_data.districts,
          search : ''


        });
        obj_this.context.loading(0);
      });
    })
    $(".search").on("focusout",function(e){
      console.log(e.target);
      $(".customer_suggestions_container").empty().css("display","none");
    });
    $(".phone").on("focusout",function(e){
      console.log(e.target);
      $(".phone_suggestions_container").empty().css("display","none");
    });

  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }
  routeChange(option){
    this.setState({
      route : option
    });
  }
  zoneChange(option){
    this.setState({
      zone : option
    });
  }
  clearValuesinState(){
    this.setState({
      person : '',
      // phone : '',
      company : '',
      gst : '',
      district : '',
      address : '',
      customer_id : '',
      category : '',
      // distributor : '',
      route: '',
      retailer_scheme : '',
      location : '',
      coordinate : '',
      specific_industry : ''
      // shopImage : '',
    });
  }
  phoneChange(e){
    this.setState({
      [e.target.name] : e.target.value
    }); 
  }

  searchChange(e){
    $(".customer_suggestions_container").empty();
    this.setState({
      [e.target.name] : e.target.value
    });
    
    if(!e.target.value){
      $(".customer_suggestions_container").css("display","none");
      return;
    }
    if (e.target.value.length < 3) {
      $(".customer_suggestions_container").css("display", "none");
      return;
    }

    this.context.loading(1);
    const obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/search/customer`;
    customer_XHR.abort();
    customer_XHR = $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        phone : e.target.value,
        customer_type:  obj_this.state.customer_type
      },
      type : "POST"
    }).done(function(return_data){
    //  alert(return_data);
      if(return_data.customers.length){
        for(var i=0;i<return_data.customers.length;i++){
          var node = singleCustomer_DOM.clone();
          node.find(".customer_name").html(return_data.customers[i]['name']);
          node.find(".customer_phone_no").html(return_data.customers[i]['tel_o']);
          node.attr("customer_id",return_data.customers[i]['id']);
          $(".customer_suggestions_container").append(node);
        }
        $(".customer_suggestions_container").css("display","block");
        obj_this.context.loading(0);
      }else{
        $(".customer_suggestions_container").css("display","none");
        obj_this.context.loading(0);
      }
    });
    
  }

  phoneSearchChange(e){
    $(".phone_suggestions_container").empty();
    this.setState({
      [e.target.name] : e.target.value
    });
    
    if(!e.target.value){
      $(".phone_suggestions_container").css("display","none");
      return;
    }
    if (e.target.value.length < 3) {
      $(".phone_suggestions_container").css("display", "none");
      return;
    }

    this.context.loading(1);
    const obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/search/customer`;
    customer_XHR.abort();
    customer_XHR = $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        phone : e.target.value,
        customer_type:  obj_this.state.customer_type
      },
      type : "POST"
    }).done(function(return_data){
    //  alert(return_data);
      if(return_data.customers.length){
        for(var i=0;i<return_data.customers.length;i++){
          var node = singlePhoneCustomer_DOM.clone();
          node.find(".customer_name").html(return_data.customers[i]['name']);
          node.find(".customer_phone_no").html(return_data.customers[i]['tel_o']);
          node.attr("customer_id",return_data.customers[i]['id']);
          $(".phone_suggestions_container").append(node);
        }
        $(".phone_suggestions_container").css("display","block");
        obj_this.context.loading(0);
      }else{
        $(".phone_suggestions_container").css("display","none");
        obj_this.context.loading(0);
      }
    });
    
  }

 

  getNewCustomerDistricts(){
    const url = `${process.env.REACT_APP_SSS}/api/get/newcustomer`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
      },
      type : "GET"
    }).done(function(return_data){
      // alert(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          states : return_data.states,
          categories : return_data.retailer_categories,
          routes : return_data.routes,
          // distributors : return_data.distributors,
          retailer_schemes : return_data.retailer_schemes,
          specific_industries : return_data.specific_industries
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }

  districtChange(option){
    // console.log(option);
    this.setState({
      district : option
    }); 
    const url = `${process.env.REACT_APP_SSS}/api/get/locations`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        district_id : option.value
      },
      type : "GET"
    }).done(function(return_data){
      // alert(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          locations : return_data.locations,
          location : ''
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });


  }
  categoryChange(option){
    // console.log(option);
    this.setState({
      category : option
    }); 
  }
  specificIndustryChange(option){
    // console.log(option);
    this.setState({
      specific_industry : option
    }); 
  }
  locationChange(option){
    // console.log(option);
    this.setState({
      location : option
    }); 
  }
  // distributorChange(option){
  //   this.setState({
  //     distributor : option
  //   }); 
  // }
  stateChange(option){
    this.setState({
      state : option,
      district : '',
      zone : ''
    }); 
    const url = `${process.env.REACT_APP_SSS}/api/get/districtsAndZones`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        state_id : option.value
      },
      type : "GET"
    }).done(function(return_data){
      // alert(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          districts : return_data.districts,
          zones : return_data.zones,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }
  retailerSchemeChange(option){
    this.setState({
      retailer_scheme : option
    }); 
  }

  formSubmit(e){
    e.preventDefault();
    if(this.state.district==''){
      if(!this.state.district?.value){
        this.districtSelect.current.focus();
        return
      }
    }
    if(!this.state.location){
      this.locationSelect.current.focus();
      return
    }
    // if(!this.state.distributor){
    //   this.distributorSelect.current.focus();
    //   return
    // }
    if(!this.state.route){
      this.routeSelect.current.focus();
      return
    }
    if(!this.state.coordinate){
      alert('Please set Location Coordinates')
      return
    }
    // if(!this.state.route){
    //   this.routeSelect.current.focus();
    //   return
    // }
    if(!this.state.zone?.value){
      alert('Please select Cluster')
      return
    }
    console.log(this.state)
    // return;

    if(!(this.state.shopCamera?.file || this.state.shopImage?.imageUrl ))
    {
        alert("Upload Shop Image");
        this.setState({
          shopCamera : {
            file : null,
            isFile : false
          }
        })
        return;
    }
    if(!(this.state.boardCamera?.file || this.state.boardImage?.imageUrl ))
    {
      alert("Upload Board Image");
      this.setState({
        boardCamera : {
          file : null,
          isFile : false
        }
      })
      return;
    }
    if(!(this.state.interiorCamera?.file || this.state.interiorImage?.imageUrl ))
    {
      alert("Upload Interior Shop Image");
      this.setState({
        interiorCamera : {
          file : null,
          isFile : false
        }
      })
      return;
    }
    const NewCustomers = this.state;

    // delete NewCustomers.districts;
    // delete NewCustomers.categories;
    // delete NewCustomers.locations;
    // delete NewCustomers.distributors;
    // delete NewCustomers.routes;


    const url = `${process.env.REACT_APP_SSS}/api/save/customer`;
    this.context.loading(1);
    var obj_this = this;
    console.log(NewCustomers);
    // return;
    var fd = new FormData();
    fd.append('sid',this.context.user_details.sid);
    if(this.state.customer_id != '')
      fd.append('customer_id',this.state.customer_id);
    fd.append('district',JSON.stringify(this.state.district));
    fd.append('address',this.state.address);
    fd.append('category',JSON.stringify(this.state.category));
    fd.append('specific_industry',JSON.stringify(this.state.specific_industry));
    fd.append('company',this.state.company);
    if(this.state.coordinate!=''){
      fd.append('coordinate',JSON.stringify(this.state.coordinate));
    }
    fd.append('customer_type',this.state.customer_type);
    // fd.append('distributor',JSON.stringify(this.state.distributor));
    if(this.state.zone?.value)
      fd.append('zone_id',JSON.stringify(this.state.zone.value));
    // fd.append('fileDeleted',this.state.fileDeleted);
    // fd.append('file_start',this.state.file_start);
    fd.append('gst',this.state.gst);
    // fd.append('image_start',this.state.image_start);
    fd.append('location', JSON.stringify(this.state.location));
    fd.append('person',this.state.person);
    fd.append('phone',this.state.phone);
    if(this.state.retailer_scheme != '')
      fd.append('retailer_scheme',JSON.stringify(this.state.retailer_scheme));
    fd.append('person',this.state.person);
    if(this.state.route != '')
      fd.append('route',JSON.stringify(this.state.route));
    if (this.state.shopCamera?.file){
      fd.append('shop_image', this.state.shopCamera.file);
      // fd.append('shop_image_deleted', this.state.shopImage.deleted);
    } 

    if (this.state.boardCamera?.file ){
      fd.append('board_image', this.state.boardCamera.file);
      // fd.append('board_image_deleted', this.state.boardImage.deleted);
    } 

    if (this.state.interiorCamera?.file){
      fd.append('interior_image', this.state.interiorCamera.file);
      // fd.append('interior_image_deleted', this.state.interiorImage.deleted);
    }  

    axios.post(url,fd)
    .then(return_data =>{
      if(return_data.data.status == "success"){
        obj_this.setState({ 
          NewCustomers : []
        });
        obj_this.state.customer_type=="D"?alert("Customer Saved"):alert("Customer Saved");
        obj_this.setState({
          company : '',          
        });
        obj_this.clearValuesinState();
        obj_this.context.loading(0);
        obj_this.props.history.replace('/customers');
      }else if(return_data.data.status == "exists"){
        alert("Customer already exists");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/customers/new');
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    });
  }

  handleLocationChange = (location) => {
    console.log('Location changed:', location);
    this.setState({
      // address : location?.address,
      coordinate : {lat : location?.coordinates?.lat, lng : location?.coordinates?.lng},

    })
  };

  handleImageChange = (key, file, imageUrl) => {
    this.setState((prevState) => {
      const currentImage = prevState[key];
  
      if (file) {
        return {
          [key]: {
            file: file,
            deleted: currentImage?.file ? false : true,
            updated: currentImage?.file ? true : false,
            imageUrl: URL.createObjectURL(file), // Use URL.createObjectURL to get the blob URL
          },
        };
      } else {
        return {
          [key]: {
            file: null,
            deleted: currentImage?.file ? true : false,
            updated: false,
            imageUrl: imageUrl || null, // Use the provided imageUrl prop or set to null
          },
        };
      }
    });
  };

  handleImageDelete = (key) => {
    this.setState({
      [key]: {
        file: null,
        deleted: true, // Set the deletion flag
        updated: false, // Reset the update flag
      },
    });
  };
  handleImageCapture = (imageURI, imgType) => {
    if (imageURI.startsWith('file://')) {
      window.resolveLocalFileSystemURL(
        imageURI,
        (fileEntry) => {
          fileEntry.file(
            (file) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                const blob = new Blob([new Uint8Array(reader.result)], { type: file.type });
                console.log(blob);
                this.setState((prevState) => {
                  let updatedState = { ...prevState };
                  if (imgType === 'shop') {
                    updatedState.shopCamera.file = blob;
                  } else if (imgType === 'indoor') {
                    updatedState.interiorCamera.file = blob;
                  } else if (imgType === 'board') {
                    updatedState.boardCamera.file = blob;
                  }
                  return updatedState;
                });
              };
              reader.readAsArrayBuffer(file);
            },
            (error) => {
              console.error('Error reading file:', error);
            }
          );
        },
        (error) => {
          console.error('Error resolving file URL:', error);
        }
      );
    } else if (imageURI.startsWith('data:image')) {
      fetch(imageURI)
        .then(res => res.blob())
        .then(blob => {
          this.setState((prevState) => {
            let updatedState = { ...prevState };
            if (imgType === 'shop') {
              updatedState.shopCamera.file = blob;
            } else if (imgType === 'indoor') {
              updatedState.interiorCamera.file = blob;
            } else if (imgType === 'board') {
              updatedState.boardCamera.file = blob;
            }
            return updatedState;
          });
        })
        .catch(err => console.error('Error converting data URI to blob:', err));
    } else {
      console.error('Invalid image URI:', imageURI);
    }
  }
  

  handleButtonClick = (e) => {
    const imgType = e.currentTarget.getAttribute('imgtype');

    this.setState((prevState) => {
      const newState = { ...prevState };
      if (imgType === 'shop') {
        newState.shopCamera = { ...prevState.shopCamera, isFile: !prevState.shopCamera.isFile };
      } else if (imgType === 'indoor') {
        newState.interiorCamera = { ...prevState.interiorCamera,isFile: !prevState.interiorCamera.isFile };
      } else if (imgType === 'board') {
        newState.boardCamera = { ...prevState.boardCamera, isFile: !prevState.boardCamera.isFile  };
      }
      return newState;
    });
  };

  

  render(){
    const compressionOptions = {
      maxSizeMB: 10,
      maxWidthOrHeight: 2048,
      useWebWorker: true,
      initialQuality: 0.7,
      stripMetadata: true,
    };

  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_retailer_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> {this.state.customer_id?"Edit " +this.state.company+ " Details":"New Customer"}</div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="customer_details_container blocks">
            <div className="customer_container">
              <div className="search_container">
                <div className="input_label">Search Customer</div>
                <input className="billing_contact_no custom_input2 search"
                  type="text"
                  name="search"
                  value={this.state.search}
                  onChange={e => this.searchChange(e)}
                  autoComplete="off"
                />
              </div>
              <div className="customer_suggestions_container">
                <div className="single_customer_details">
                  <div className="customer_name"></div>
                  <div className="customer_phone_no"></div>
                </div>
              </div>
              <div className="input_label">Phone</div>
              <input className="billing_contact_no custom_input phone"
                type="tel"
                name="phone"
                value={this.state.phone}
                onChange={e => this.phoneSearchChange(e)}
                pattern="^[0]?[1-9][0-9]{9}$"
                required
                autoComplete="off"
              />
              <div className="phone_suggestions_container">
                <div className="single_phone_customer_details">
                  <div className="customer_name"></div>
                  <div className="customer_phone_no"></div>
                </div>
              </div>
           
              <div className="input_label">Customer Name</div>
              <input className="company input custom_input"
                type="text"
                name="company"
                value={this.state.company}
                onChange={this.formChange}
                required
                autoComplete="off"
              />

              </div>
              <div className="input_label">Contact Person</div>
              <input className="billing_contact_no input custom_input"
                type="text"
                name="person"
                value={this.state.person}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
            
               <div className="input_label">VATIN</div>
              <input className="billing_contact_no input custom_input"
                type="text"
                name="gst"
                value={this.state.gst}
                onChange={this.formChange}
                autoComplete="off"
                // required
              />
              <div>
                {this.state.capturedPhotos.map((photo, index) => (
                  <img
                    key={index}
                    style={{ display: 'block', width: '90%' }}
                    src={photo}
                    alt={`Captured Photo ${index + 1}`}
                  />
                ))}
              </div>
              <span className="camera-image-upload" onClick={this.handleButtonClick} imgtype={'shop'}>
                <i className="fa fa-home" aria-hidden="true"></i>
                <label htmlFor="image" className="camera-input-label">
                  Shop
                  <br />
                </label>
              </span>

              {
                this.state.shopCamera.isFile ?
                  <CameraMultiComponent onImageCapture={(imageURI) => this.handleImageCapture(imageURI, 'shop')} imgType={'shop'} /> : undefined
              }
              {
                this.state.shopCamera.file ?
                  undefined :
                  <ImageUploader
                    label="Shop Image"
                    onChange={(file) => this.handleImageChange('shopImage', file, this.state.shopImage?.imageUrl)}
                    imageUrl={this.state.shopImage?.imageUrl}
                    onDelete={() => this.handleImageDelete('shopImage')}
                    compressionOptions={compressionOptions}
                  />
              }
              <span className="camera-image-upload" onClick={this.handleButtonClick} imgtype={'indoor'}>
                <i className="fa fa-columns" aria-hidden="true"></i>
                <label htmlFor="image" className="camera-input-label">
                  Interior
                  <br />
                </label>
              </span> 
              {
                this.state.interiorCamera.isFile ?
                  <CameraMultiComponent onImageCapture={(imageURI) => this.handleImageCapture(imageURI, 'indoor')} imgType={'indoor'} /> : undefined
              }
              {
                this.state.interiorCamera.file ?
                  undefined :
                  <ImageUploader
                    label="Interior Image"
                    onChange={(file) => this.handleImageChange('interiorImage', file, this.state.interiorImage?.imageUrl)}
                    imageUrl={this.state.interiorImage?.imageUrl}
                    onDelete={() => this.handleImageDelete('interiorImage')}
                    compressionOptions={compressionOptions}
                  />
              }
              <span className="camera-image-upload" onClick={this.handleButtonClick} imgtype={'board'}>
                <i className="fa fa-building" aria-hidden="true"></i>
                <label htmlFor="image" className="camera-input-label">
                  Board
                  <br />
                </label>
              </span> 
              {
                this.state.boardCamera.isFile ?
                  <CameraMultiComponent onImageCapture={(imageURI) => this.handleImageCapture(imageURI, 'board')} imgType={'board'} /> : undefined
              }
              {
                this.state.boardCamera.file ?
                  undefined :
                  <ImageUploader
                    label="Board Image"
                    onChange={(file) => this.handleImageChange('boardImage', file, this.state.boardImage?.imageUrl)}
                    imageUrl={this.state.boardImage?.imageUrl}
                    onDelete={() => this.handleImageDelete('boardImage')}
                    compressionOptions={compressionOptions}
                  />
              }      
             
              <div className="map-spacer">
              {this.state.coordinate?
               <MapContainer initialCoordinates={this.state.coordinate} 
              //  onLocationChange={this.handleLocationChange}
                />:null
              }
              </div>
              <div className="input_label">Location Coordinates</div>
              <div className="location_container">
                <input className=" location complaint input custom_input"
                  type="text"
                  name="location"
                  value={this.state.coordinate?this.state.coordinate.lat+", "+this.state.coordinate.lng:"Enable GPS Permission"}
                  onChange={this.formChange}
                  autoComplete="off"
                  disabled
                  required
                />
                <div className="location_button">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
              </div>
              <div className="input_label">Address</div>
              <textarea className="input billing_address custom_input" 
                name="address"
                value={this.state.address}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
               <div className="input_label">Market Category</div>
              <Select 
                options={this.state.categories}  
                value ={this.state.category}
                className="district" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.categoryChange(e)}
                required
                
              />
              <div className="input_label">Channel Industry</div>
              <Select 
                options={this.state.specific_industries}  
                value ={this.state.specific_industry}
                className="district" 
                onChange={e => this.specificIndustryChange(e)}         
              />
              <div className="input_label">Governance</div>
              <Select 
                options={this.state.states}  
                value ={this.state.state}
                className="district" 
                ref={this.stateSelect}
                onChange={e => this.stateChange(e)}
                required
              />
               <div className="input_label">Wilayat</div>
              <Select 
                options={this.state.districts}  
                value ={this.state.district}
                className="district" 
                ref={this.districtSelect}
                onChange={e => this.districtChange(e)}
                required
                
              />
               <div className="input_label">Location</div>
              <Select 
                options={this.state.locations}  
                value ={this.state.location}
                className="district" 
                ref={this.locationSelect}
                onChange={e => this.locationChange(e)}
                required
                
              />
              {/* <div className="input_label">Distributor</div>
              <Select 
                options={this.state.distributors}  
                value ={this.state.distributor}
                name = "distributor"
                className="district" 
                ref={this.distributorSelect}
                onChange={e => this.distributorChange(e)}
                required
                
              /> */}
               <div className="input_label">Route</div>
              <Select 
                options={this.state.routes}  
                value ={this.state.route}
                name = "route"
                className="district" 
                ref={this.routeSelect}
                onChange={e => this.routeChange(e)}
                // required
                
              />
              <div className="input_label">Cluster</div>
              <Select 
                options={this.state.zones}  
                value ={this.state.zone}
                name = "zone"
                className="district" 
                onChange={e => this.zoneChange(e)}
              />
               {/* <div className="input_label">Retailer Schemes</div>
              <Select 
                options={this.state.retailer_schemes}  
                value ={this.state.retailer_scheme}
                name = "route"
                className="district" 
                // ref={this.routeSelect}
                onChange={e => this.retailerSchemeChange(e)}
                required
                
              /> */}
                            
            </div>
            <div className="schedules_table_container blocks"
             
            >
             
            </div>
            <button type="submit" 
            className="submit_button"
            
            >
              <i className="far fa-save"></i> {this.state.customer_id?"Update":"Save"}
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewCustomer;
NewCustomer.contextType = MyContext;
